import React, { useState, useEffect } from 'react';
import Logo from '../assets/images/logo.png';
import NavBurger from '../assets/svg/navburger.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/nav.scss';

const Nav = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  
  // Check if we're on pages that should have transparent navbar
  const isHomePage = location.pathname === '/' || location.pathname === '/Home';
  const isMechVentPage = location.pathname === '/Mechanische-ventilatie';
  const isWTWPage = location.pathname === '/WTW-systemen';
  const isDakVentPage = location.pathname === '/Dakventilatie';
  const shouldBeTransparent = isHomePage || isMechVentPage || isWTWPage || isDakVentPage;
  
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      setIsScrolled(scrollTop > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Determine navbar class based on page and scroll state
  const getNavbarClass = () => {
    if (shouldBeTransparent) {
      return isScrolled ? 'navbar-scrolled' : 'navbar-transparent';
    } else {
      return 'navbar-white'; // Always white background on other pages
    }
  };

  // Handle mobile menu toggle
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Handle navigation and close mobile menu
  const handleNavClick = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`navbar ${getNavbarClass()}`}>
      <div className="navbar-container">
        <div className="navbar-logo" onClick={() => navigate('/Home')}>
          <img src={Logo} alt="FreshAir Logo" className="img"/>
        </div>
        
        {/* Desktop Menu */}
        <div className="navbar-menu">
          <button className="navbar-link" onClick={() => navigate('/Home')}>Home</button>
          <button className="navbar-link" onClick={() => navigate('/Mechanische-ventilatie')}>Mechanische ventilatie</button>
          <button className="navbar-link" onClick={() => navigate('/WTW-systemen')}>WTW systemen</button>
          <button className="navbar-link" onClick={() => navigate('/Dakventilatie')}>Dakventilatie</button>
          <button className="navbar-link" onClick={() => navigate('/Tarieven')}>Tarieven</button>
          <button className="navbar-link" onClick={() => navigate('/Contact')}>Contact</button>
        </div>

        {/* Mobile Menu Button */}
        <div className="mobile-menu-button" onClick={toggleMobileMenu}>
          <img src={NavBurger} alt="Menu" className="navburger-icon"/>
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
        <div className="mobile-menu-content">
          <button className="mobile-nav-link" onClick={() => handleNavClick('/Mechanische-ventilatie')}>Mechanische ventilatie</button>
          <button className="mobile-nav-link" onClick={() => handleNavClick('/WTW-systemen')}>WTW systemen</button>
          <button className="mobile-nav-link" onClick={() => handleNavClick('/Dakventilatie')}>Dakventilatie</button>
          <button className="mobile-nav-link" onClick={() => handleNavClick('/Tarieven')}>Tarieven</button>
          <button className="mobile-nav-link" onClick={() => handleNavClick('/Contact')}>Contact</button>
        </div>
      </div>
    </nav>
  );
};

export default Nav;